import {NotifierOptions} from 'angular-notifier';

export const notifierCustomOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12,
    },
    vertical: {
      position: 'top',
      distance: 54,
      gap: 10,
    },
  },
  behaviour: {
    autoHide: 3000,
    onClick: 'hide',
    showDismissButton: false,
    stacking: 5,
  },
  animations: {
    enabled: true,
    show: {
      preset: 'fade', // 'slide' | 'fade'
      speed: 300,
      easing: 'ease', // 'ease' | 'linear' | 'ease-in' | 'ease-out' | 'ease-in-out'
    },
    hide: {
      preset: 'fade', // 'fade' | 'slide'
      speed: 300,
      easing: 'ease', // 'linear' | 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out'
      offset: 50 // number | false, when hiding multiple notifications at once
    },
    shift: {
      speed: 300,
      easing: 'ease' // All standard CSS easing methods work
    },
    overlap: 150, // number | false
  }
};
